import { createFromIconfontCN } from '@ant-design/icons-vue';

const IconFont = createFromIconfontCN({
    scriptUrl: '/iconfont.js' // 在 iconfont.cn 上生成
})

export {
    IconFont
}